import qs from "qs";
import { CheckInviteDTO, CheckInviteResponse, SendInviteDTO } from "./models";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { DefaultResponse } from "shared/types/general";

export const CheckInviteApi = async (dto: CheckInviteDTO) => {
  const { data } = await api.post<CheckInviteResponse>(
    API_ROUTES.CHECK_INVITE,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};

export const SendInviteApi = async (dto: SendInviteDTO) => {
  const { data } = await api.post<DefaultResponse>(
    API_ROUTES.SEND_INVITE,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};
